import "@/styles/components/site-header.css";
import delegate from "delegate-it";
import { fireEvent } from "@/scripts/common/util";
import { gsap } from "gsap";

const siteHeader = document.querySelector(".site-header");
const scrollPixel = document.querySelector(".scroll-pixel");
const siteMenu = document.getElementById("site-menu");

const handleMenuOpen = () => {
  gsap
    .timeline({
      onComplete: () => {
        requestAnimationFrame(() => {
          siteMenu.classList.add("is-open");
        });
      },
    })
    .fromTo(siteMenu.querySelector(".site-menu-wrapper"), { xPercent: 100 }, { xPercent: 0, ease: "ease-in" })
    .fromTo(
      siteMenu.querySelectorAll(".site-menu-header button"),
      { opacity: 0, yPercent: 20 },
      { opacity: 1, yPercent: 0, stagger: 0.2, ease: "ease-in" },
    )
    .fromTo(
      siteMenu.querySelectorAll(".menu-services li"),
      { opacity: 0, yPercent: 20 },
      { opacity: 1, yPercent: 0, stagger: 0.1, ease: "ease-in" },
      "<",
    )
    .fromTo(
      siteMenu.querySelectorAll(".menu-secondary"),
      { opacity: 0, yPercent: 10 },
      { opacity: 1, yPercent: 0, stagger: 0.2, ease: "ease-in" },
      "<40%",
    )
    .fromTo(
      siteMenu.querySelectorAll(".site-menu-actions > li"),
      { opacity: 0, yPercent: 10 },
      { opacity: 1, yPercent: 0, stagger: 0.2, ease: "ease-in" },
      "<",
    )
    .duration(1.5);
};

const handleMenuClose = () => {
  gsap
    .timeline({
      onComplete: () => {
        requestAnimationFrame(() => {
          siteMenu.classList.remove("is-open");
        });
      },
    })
    .to(siteMenu.querySelectorAll(".site-menu-actions > li"), {
      opacity: 0,
      yPercent: -20,
      stagger: 0.2,
      ease: "ease-in",
    })
    .to(siteMenu.querySelectorAll(".menu-secondary"), { opacity: 0, yPercent: -20, stagger: 0.2, ease: "ease-in" }, "<")
    .to(
      siteMenu.querySelectorAll(".menu-services > li"),
      { opacity: 0, yPercent: -10, stagger: 0.2, ease: "ease-in" },
      "<",
    )
    .to(
      siteMenu.querySelectorAll(".site-menu-header button"),
      { opacity: 0, yPercent: -10, stagger: 0.2, ease: "ease-in" },
      "<",
    )
    .to(siteMenu.querySelector(".site-menu-wrapper"), { xPercent: 100 })
    .duration(0.5);

  fireEvent("slidetoggle:reset", siteMenu.querySelectorAll('[data-slide-toggle][aria-expanded="true"]'));
};

export default {
  init: () => {
    if (siteHeader && scrollPixel) {
      const observer = new IntersectionObserver(
        ([e]) => siteHeader.classList.toggle("is-stuck", e.intersectionRatio < 1),
        {
          threshold: [1],
        },
      );

      observer.observe(document.querySelector(".scroll-pixel"));
    }

    delegate("html", "sitemenu:open", handleMenuOpen);
    delegate("html", "sitemenu:close", handleMenuClose);
  },
};
